import React, { PureComponent } from 'react'
import BEMHelper from '@ynap/bem-helper'
import { FlagWithCountry } from '@ynap/flag'
import Notification from '@ynap/notification'

const bem = new BEMHelper('ChangeCountry')
class ChangeCountry extends PureComponent {
    state = {
        error: null,
    }

    handleCountryChange = () => {
        // native apps do not have the country picker
        if (this.props.deviceType) return

        try {
            window.SF.triggerChangeCountryFlow(true, null, 'checkout', { clearMessages: true })
        } catch (error) {
            this.setState({ error })
        }
    }

    render() {
        const { messages, className, deviceType } = this.props
        return (
            <div className={bem(className)}>
                {this.state.error && <Notification message={messages.errors.generic()} type="error" arrow={'top'} className={bem('error')} />}
                <FlagWithCountry
                    {...this.props}
                    className={bem('content', deviceType && 'webview')}
                    prefixText={messages.addressSelectionForm.shippingTo()}
                    handleClick={this.handleCountryChange}
                />
            </div>
        )
    }
}

export default ChangeCountry
